import { useDarkMode } from '../DarkModeContext';
import useIsVisible from '../isVisible';
import { useRef } from 'react';

import Samuel from '../pic/Samuel.png';
import David from '../pic/David.jpg';
import Manuel from '../pic/Manuel.jpg';
import Konstantin from '../pic/Konstantin.png';
import Dominik from '../pic/Dominik.jpg';

const InitialsAvatar = ({ initials, isDarkMode }) => (
  <div className={`h-full aspect-square rounded-full flex items-center justify-center text-4xl font-bold ${
    isDarkMode ? 'bg-Template-1/40 text-Template-2' : 'bg-Template-1/20 text-Template-0'
  }`}>
    {initials}
  </div>
);

const TeamMember = ({ photo, initials, name, roles, isDarkMode }) => (
  <div className={`flex flex-col items-center rounded-2xl border p-6 ${
    isDarkMode ? 'bg-gray-700/40 border-gray-600' : 'bg-white border-Template-2 shadow-sm'
  }`}>
    <div className="h-36 w-36 mb-4 flex items-center justify-center">
      {photo
        ? <img src={photo} alt={name} className="h-full w-full rounded-full object-cover" />
        : <InitialsAvatar initials={initials} isDarkMode={isDarkMode} />
      }
    </div>
    <div className={`font-bold text-lg mb-2 ${isDarkMode ? 'text-white' : 'text-Template-0'}`}>{name}</div>
    <ul className={`text-sm space-y-1 text-center ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
      {roles.map(r => <li key={r}>{r}</li>)}
    </ul>
  </div>
);

function UeberUns() {
  const { isDarkMode } = useDarkMode();

  const ref = useRef();
  const visible = useIsVisible(ref);

  const team = [
    {
      photo: Samuel,
      name: 'Samuel Weißenbacher',
      roles: ['Projektleitung', 'App-Entwicklung', 'BLE-Integration'],
    },
    {
      photo: David,
      name: 'David Muttenthaler',
      roles: ['PCB-Layout & Design', 'PCB-Fertigung', 'Gehäuse-Design & Fertigung'],
    },
    {
      photo: Manuel,
      name: 'Manuel Weilguny',
      roles: ['Firmware / Software', 'IMU-Modul (LSM6DSV)', 'Orientierungserkennung'],
    },
    {
      photo: Konstantin,
      name: 'Konstantin Lausecker',
      roles: ['Würfel gießen', 'Software-Architektur'],
    },
    {
      photo: Dominik,
      name: 'Dominik Neugebauer',
      roles: ['App-Entwicklung', 'BLE-Kommunikation', 'App-seitige SW-Module'],
    },
  ];

  return (
    <div
      ref={ref}
      className={`px-8 py-16 min-h-screen transition-opacity ease-in duration-700 ${visible ? 'opacity-100' : 'opacity-0'} ${
        isDarkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'
      }`}
    >
      <div className="max-w-4xl mx-auto">
        <h2 className={`text-4xl font-bold mb-2 ${isDarkMode ? 'text-white' : 'text-Template-0'}`}>Unser Team</h2>
        <hr className={`border-t-2 my-6 ${isDarkMode ? 'border-gray-600' : 'border-Template-2'}`} />
        <p className={`text-base leading-relaxed mb-10 max-w-2xl ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
          SmartDice ist ein universitäres Projektteam im ersten Master-Semester. Fünf Personen,
          eine gemeinsame Idee – von der Elektronik über die Firmware bis zur App.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {team.map((m) => (
            <TeamMember key={m.name} {...m} isDarkMode={isDarkMode} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default UeberUns;
